module.exports = __webpack_public_path__ + "static/media/2.7e8b93d3.jpg";